import { useContext, useMemo, useRef } from 'react'
import styles from './index.module.scss'
import { VideoContext } from '../../hooks/VideoContext'
// 格式化时间 (秒 -> mm:ss)
function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}
export default function VideoController(props) {
    const {
        isPlaying,
        currentTime,
        duration,
        seekTo,
        togglePlayPause,
    } = useContext(VideoContext)

    // 进度条点击跳转
    const handleProgressClick = (e) => {
        if (!duration) return;

        const progressBar = e.currentTarget;
        const rect = progressBar.getBoundingClientRect();
        const pos = (e.clientX - rect.left) / rect.width;
        const newTime = pos * duration;
        
        seekTo(newTime);
    };

    return (
        <div className={styles.VideoController}>
            <div
                className={`${styles.PlayStatus} ${isPlaying ? styles.Playing : styles.Pause}`}
                onClick={togglePlayPause}
            ></div>
            <div className={styles.TimeContent}>
                <span>{formatTime(currentTime)}</span>
                <span>/</span>
                <span>{formatTime(duration)}</span>
            </div>
            <div className={styles.ProgressBar} onClick={handleProgressClick} >
                <div className={styles.Progress} style={{width: `${duration == 0 ? 0 : currentTime / duration * 100}%`}}></div>
            </div>
        </div>
    )
}